import {ExpenseTypeDao} from '../../dao';
import {ExpenseTypeModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateExpenseType(
    userData: Record<string, string>,
    expenseTypeId: number,
    update: Record<string, any>
) {
    try {
        const result = await ExpenseTypeDao.updateExpenseType(userData.userToken, expenseTypeId, update);

        const resultParsed = ExpenseTypeModel.parseExpenseType(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
